import { legacy_createStore as createStore } from 'redux';
import Reducer from './reducer/reducer';

const Store = createStore(Reducer);

export default Store
